import type { IsicDetail } from 'src/shared/types/engine';

export type EngineActivityFields = {
    isicDetail: IsicDetail | null;
};

export type IsicActivityLines = {
    /** Human-readable ISIC section name (e.g. "Agriculture, Forestry and Fishing"). */
    sectionLine: string;
    /** Human-readable activity description; em dash when activity is section-level only. */
    classLine: string;
    /** Tooltip for sectionLine, prefixed with ISIC code (e.g. "[A] Agriculture, Forestry and Fishing"). */
    sectionTooltip: string;
    /** Tooltip for classLine, prefixed with ISIC code; em dash when activity is section-level only. */
    classTooltip: string;
};

const prefixCode = (code: string, description: string) => `[${code}] ${description}`;

export function formatIsicActivityLines(activity: EngineActivityFields | null | undefined): IsicActivityLines | null {
    const detail = activity?.isicDetail;
    if (!detail) {
        return null;
    }

    const sectionAncestor = detail.ancestors[0];
    const sectionLine = sectionAncestor?.description ?? detail.description;
    const sectionCode = sectionAncestor?.code ?? detail.code;
    const isSectionLevel = detail.ancestors.length === 0;
    const classLine = isSectionLevel ? '—' : detail.description;

    return {
        sectionLine,
        classLine,
        sectionTooltip: prefixCode(sectionCode, sectionLine),
        classTooltip: isSectionLevel ? '—' : prefixCode(detail.code, detail.description),
    };
}
